/* eslint-disable jsx-a11y/media-has-caption */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { ButtonContainer, Button, ButtonText } from '../button/button';
import '@reach/dialog/styles.css';
import './modal-lightbox.css';

export default class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.onKeyDown = this.onKeyDown.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  showModal = () => this.setState({ open: true });

  hideModal = () => this.setState({ open: false });

  onKeyDown = ({ key }) => {
    const { open } = this.state;
    if (open && key === 'Escape') {
      this.hideModal();
    }
  };

  disableScrolling = (open) => {
    // Disables scrolling when the modal is open, as suggested by
    // https://www.w3.org/TR/2017/NOTE-wai-aria-practices-1.1-20171214/examples/dialog-modal/dialog.html
    if (open) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = null;
      document.documentElement.style.overflow = null;
    }
  };

  render() {
    const { open } = this.state;
    const { video: { file: { url } } } = this.props;

    if (typeof document !== 'undefined') {
      this.disableScrolling(open);
    }

    return (
      <>
        <ButtonContainer>
          <Button
            onClick={() => this.showModal()}
            onKeyUp={({ key }) => {
              if (key === 'Enter') {
                this.showModal();
              }
            }}
          >
            <ButtonText>Watch the video</ButtonText>
          </Button>
        </ButtonContainer>

        <DialogOverlay
          style={{ backgroundColor: 'rgba(0,0,0,0.85)' }}
          isOpen={open}
        >
          <DialogContent
            sx={{
              padding: 0,
              width: ['90vw', '75vw'],
              background: 'transparent',
            }}
          >
            <span
              role="button"
              tabIndex={0}
              onClick={() => this.hideModal()}
              onKeyUp={({ key }) => {
                if (key === 'Enter') {
                  this.hideModal();
                }
              }}
              sx={{
                color: 'white',
                fontWeight: 'bold',
                display: 'block',
                textAlign: 'right',
                outline: 'none',
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
            >
              CLOSE
            </span>
            <video autoPlay src={url} sx={{ width: '100%', display: 'block' }} controls>Your browser does not support video.</video>
          </DialogContent>
        </DialogOverlay>
      </>
    );
  }
}

Modal.propTypes = {
  video: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
      contentType: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
